<template>
  <div>
    <loading v-if="loading"/>
    <div v-if="isAuthenticated">
      <AppHeader/>

      <section class="navbar-space no-padding">
        <feed-item v-for="(feed, index) in fakeFeed" :key="index" :feed="feed"/>
      </section>

      <AppFooter/>
    </div>
    <div v-if="!isAuthenticated && authStatus !== 'loading'">
      <FirstPageReg/>
    </div>
  </div>
</template>


<script>
import fakeFeed from "./fakeFeed";
import FeedItem from "./feedItem.vue";
import { mapGetters } from "vuex";
//import Login from "@/components/login/login";
import FirstPageReg from "@/components/login/firstPageReg";
import AppFooter from "../pagecomp/appFooter";
import AppHeader from "../pagecomp/appHeader";

import { AUTH_LOGOUT } from "@/store/actions/auth";

export default {
  components: {
    //Login,
    FirstPageReg,
    FeedItem,
    AppFooter,
    AppHeader
  },
  name: "home",
  computed: {
    ...mapGetters(["isAuthenticated", "authStatus"]),
    loading: function() {
      return this.authStatus === "loading" && !this.isAuthenticated;
    }
  },
  data() {
    return { fakeFeed };
  },
  methods: {
    logout: function() {
      this.$store.dispatch(AUTH_LOGOUT).then(() => {
        this.$router.push("/");
      });
    }
  }
};
</script>
